import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import { Grid, Box, TableBody, TableRow, TableCell, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import Category from "../../../actions/Catagory";
import AddProductForm from "../../../components/forms/updateProductListForm";
import Popup from "../../../components/customHelpers/Popup";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FiEye } from "react-icons/fi";
import InfoComponent from "../../../components/InfoComponent";
import { Search } from "@mui/icons-material";

const headCells = [
  { id: "name", label: "Name" },
  { id: "sku", label: "SKU" },
  { id: "quantity", label: "Quantity" },
  { id: "createdAt", label: "CreatedAt" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const CategoryDetailPage = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { getProductsByCategory } = Category();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productLists, setProductLists] = useState([]);
  const [Id, setId] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  let location = useLocation();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];

  useEffect(() => {
    getProductData(value);
    setId(value);
  }, [value, reload]);

  const getProductData = (id) => {
    setValues({ ...values, loading: true });
    getProductsByCategory(id ? id : Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProductLists(data.product);
        setProductData(data.product);
      }
    });
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(productLists, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["name", "sku"];
        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const totalQuantity = productLists?.reduce(
    (total, list) => total + parseInt(list.quantity, 10),
    0
  );

  return (
    <Layout>
      <div
        className="card"
        style={{ overflow: "hidden", boxSizing: "border-box" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            gap: { xs: 1, sm: 0 },
            "@media (max-width: 455px)": {
              flexDirection: "column",
              alignItems: "flex-start",
            },
            px: { xs: 1, sm: 2 },
          }}
        >
          <Typography
            variant="h6"
            className="page-header"
            sx={{ whiteSpace: "nowrap" }}
          >
            <ArrowBackIcon
              style={{ cursor: "pointer", verticalAlign: "middle" }}
              onClick={() => {
                history.push("/categories");
              }}
            />
            <span style={{ marginLeft: "6px" }}>Category Detail</span>
          </Typography>
        </Box>
        <InfoComponent pageKey="categories" />

        <div
          className="search-header-container"
          style={{
            marginBottom: 0,
            marginTop: 10,
            flex: 1,
            maxWidth: 260,
            minWidth: 260,
            px: { xs: 1, sm: 2 },
          }}
        >
          <div className="search-header-flex">
            <div className="search-container">
              <Search className="search_icon" />
              <input
                type="text"
                onChange={handleSearch}
                placeholder="Search Product"
                className="search-input"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>

        <Grid container sx={{ px: { xs: 1, sm: 2 } }}>
          <Grid item xs={12} className="card__body">
            {loading ? (
              <Loading />
            ) : (
              <Box sx={{ overflowX: "auto", width: "100%" }}>
                <Box
                  sx={{
                    minWidth: { xs: "100%", sm: "800px" },
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <TblContainer sx={{ tableLayout: "fixed", width: "100%" }}>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell
                              style={{
                                width: { xs: "30%", sm: "25%" },
                                whiteSpace: { xs: "normal", sm: "nowrap" },
                                wordBreak: { xs: "break-word", sm: "normal" },
                              }}
                            >
                              {item?.name}
                            </TableCell>
                            <TableCell
                              style={{
                                width: { xs: "25%", sm: "20%" },
                                whiteSpace: { xs: "normal", sm: "nowrap" },
                                wordBreak: { xs: "break-word", sm: "normal" },
                              }}
                            >
                              {item.sku}
                            </TableCell>
                            <TableCell
                              style={{
                                width: { xs: "20%", sm: "20%" },
                                whiteSpace: { xs: "normal", sm: "nowrap" },
                                wordBreak: { xs: "break-word", sm: "normal" },
                              }}
                            >
                              {item?.productLists?.reduce(
                                (sum, list) =>
                                  sum + parseInt(list.quantity, 10),
                                0
                              )}
                            </TableCell>
                            <TableCell
                              style={{
                                width: { xs: "20%", sm: "25%" },
                                whiteSpace: { xs: "normal", sm: "nowrap" },
                                wordBreak: { xs: "break-word", sm: "normal" },
                              }}
                            >
                              {new Date(item.createdAt).toLocaleDateString()}
                            </TableCell>
                            <TableCell
                              style={{
                                width: { xs: "15%", sm: "10%" },
                                whiteSpace: "nowrap",
                                minWidth: { xs: "80px", sm: "100px" },
                              }}
                            >
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/product/${item.id}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={5} />
                      )}
                    </TableBody>
                  </TblContainer>
                </Box>
                <TblPagination />
              </Box>
            )}
          </Grid>
        </Grid>

        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
        <Notification notify={notify} setNotify={setNotify} />
        <Popup
          title="Product List Update Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddProductForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setProducts={setProductLists}
            getProductData={getProductData}
            id={value}
            edite={edite}
          />
        </Popup>
      </div>
    </Layout>
  );
};

export default CategoryDetailPage;
